import * as Linking from "expo-linking";
import { Platform } from "react-native";

import { getAppUrl } from "./app-url";
import { normalizeAuthRedirectPath } from "./auth-redirect";

export function getAuthCallbackUrl(callbackUrl = "/dashboard") {
  const safeCallbackUrl = normalizeAuthRedirectPath(callbackUrl);
  return Platform.OS === "web"
    ? `${getAppUrl("/auth/callback")}?next=${encodeURIComponent(safeCallbackUrl)}`
    : Linking.createURL("auth/callback", {
        queryParams: { next: safeCallbackUrl },
      });
}
